// extracted by mini-css-extract-plugin
module.exports = {"accordion":"Sidebar_accordion__WILMN","accordionDetails":"Sidebar_accordionDetails__2gB2E","rights":"Sidebar_rights__3C46P","footer":"Sidebar_footer__10gh0"};